import EventBus from '../_event-bus'
import RequestHelper from '../_request-helper'

const CART_ADD_ENDPOINT = process.env.CART_ADD_ENDPOINT
const CART_CLEAR_ENDPOINT = process.env.CART_CLEAR_ENDPOINT
const CART_REMOVE_ENDPOINT = process.env.CART_REMOVE_ENDPOINT
const CART_UPDATE_ENDPOINT = process.env.CART_UPDATE_ENDPOINT

class CartService {
  static handleAddToCart = () => {
    EventBus.$on('add-to-cart', ({ count = 1, id }) => {
      this.makeRequest(CART_ADD_ENDPOINT, { count, id })
    })
  }

  static handleClearCartListener = () => {
    EventBus.$on('clear-cart', () => this.makeRequest(CART_CLEAR_ENDPOINT))
  }

  static handleRemoveFromCart = () => {
    EventBus.$on('remove-from-cart', ({ id }) => this.makeRequest(`${CART_REMOVE_ENDPOINT}/${id}`))
  }

  static handleSetItemCount = () => {
    EventBus.$on('set-item-count', ({ count, id }) =>
      this.makeRequest(`${CART_UPDATE_ENDPOINT}/${id}`, { count })
    )
  }

  static makeRequest = async (endpoint, payload = {}) => {
    try {
      const { data } = await RequestHelper.post(endpoint, payload)

      EventBus.$emit('update-cart', data)

      if (endpoint === CART_ADD_ENDPOINT) {
        let award = data.find(item => {
          return item.id === payload.id;
        });

        EventBus.$emit('open-modal-added-to-cart', { modal: award })
      }
    } catch (err) {
      if (err.response.status === 401) {
        window.location.reload(true)
      }
      console.log(`err =>`, err)
    }
  }

  static init = () => {
    this.handleAddToCart()
    this.handleClearCartListener()
    this.handleRemoveFromCart()
    this.handleSetItemCount()
  }
}

window.addEventListener('load', CartService.init)
